/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Topbar/SupportAuditInfo/Content"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral800 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.800'
        })
let constantData = 'xid:'
let authAccessTokenDataXidValueData = fromData.useDataValue({ viewPath,
context: 'auth',
path: 'access_token_data.xid',
})
let constantData1 = '•'
let globalCurrentLocationNameValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'current_location.name',
})
let constantData2 = '• For user:'
let authAccessTokenDataForUserIdValueData = fromData.useDataValue({ viewPath,
context: 'auth',
path: 'access_token_data.for_user_id',
})
let constantData3 = '• Ref:'
let authAccessTokenDataRefValueData = fromData.useDataValue({ viewPath,
context: 'auth',
path: 'access_token_data.ref',
})
let aggregateData = fromAggregate.join(constantData, authAccessTokenDataXidValueData, constantData1, globalCurrentLocationNameValueData, constantData2, authAccessTokenDataForUserIdValueData, constantData3, authAccessTokenDataRefValueData)
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--pl-1-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-2-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-3-Z1Yf8zk': dtColorsNeutral800,'--bbrr-4-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bblr-5-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 cursor="default"
 fontSize={8}
 color={dtColorsNeutral200}
 textTransform="uppercase"
 data="'xid:'"
 data="auth.access_token_data.xid"
 data="'•'"
 data="global.current_location.name"
 data="'• For user:'"
 data="auth.access_token_data.for_user_id"
 data="'• Ref:'"
 data="auth.access_token_data.ref"
 aggregate="/Simple/Data/aggregate.js join"
 text={aggregateData}
/>
</div>
{children}
</React.Fragment>)
}